import { useState } from 'react';
import { VegaTable } from '../../common';
import VegaText from '../../common/VegaText';
import { Typography } from '@mui/material';
import { GAZZETTED_HOLIDAYS_MOCK_DATA } from './GazettedHolidaysMockData';
import { Box } from '@mui/system';
import Vega_Text from '../../common/v3/Vega_Text';

const ListOfGazettedHolidays = () => {
  const [holidays, setHolidays] = useState<any>(GAZZETTED_HOLIDAYS_MOCK_DATA);

  const columnRef = [
    {
      field: 'name',
      headerName: '  Holiday',
      flex: 0.5,
    },
    {
      field: 'date',
      headerName: '  Date',
      flex: 0.6,
    },
    {
      field: 'description',
      headerName: '  States',
      flex: 0.6,
    },
  ];

  return (
    <>
      <Box sx={{ pt: 3, marginLeft: 3 }}>
        <Vega_Text text="Gazetted Holidays" fontWeight={500} mb={2} />
      </Box>
      <VegaTable
        noTopRadius
        data={holidays}
        columnDef={columnRef}
        idColumn={'id'}
        pageSize={5}
      />
    </>
  );
};

export default ListOfGazettedHolidays;
